import { callApi } from "./callApi";
import { CustomerAccessTransfer } from "src/models/siteAuthenticationClientsModels";

interface CustomerAccessTransferProps {
  payload: {
    tid: string;
  };
}

export const customerAccessTransfer = ({
  payload,
}: CustomerAccessTransferProps): Promise<CustomerAccessTransfer> => {
  return callApi({
    payload,
    method: "POST",
    path: `/api/v1/micro-frontends/customer-access/transfer`,
  });
};

interface siteAuthenticationMasterdataProps {
  xIsonCustomerToken: string;
}

export const siteAuthenticationMasterdata = ({
  xIsonCustomerToken,
}: siteAuthenticationMasterdataProps) => {
  return callApi({
    xIsonCustomerToken,
    path: `/api/v1/micro-frontends/site-authentication/site-masterdata`,
  });
};

interface AuthenticationUrlProps {
  xIsonCustomerToken: string;
}

export const authenticationUrl = ({
  xIsonCustomerToken,
}: AuthenticationUrlProps): Promise<{
  attachedState: string;
  authenticationUrl: string;
}> => {
  return callApi({
    method: "POST",
    xIsonCustomerToken,
    path: `/api/v1/micro-frontends/site-authentication/authentication-url`,
  });
};

interface AuthenticationCallbackProps {
  xIsonCustomerToken: string;
  searchParams: string;
}

export const authenticationCallback = ({
  xIsonCustomerToken,
  searchParams,
}: AuthenticationCallbackProps): Promise<{
  msgId: string;
}> => {
  return callApi({
    method: "POST",
    xIsonCustomerToken,
    path: `/api/v1/micro-frontends/site-authentication/authentication-callback${searchParams}`,
  });
};
